/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcQuestionCircleLargeFill({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M1.1 12C1.1 5.98 5.98 1.1 12 1.1S22.9 5.98 22.9 12 18.02 22.9 12 22.9 1.1 18.02 1.1 12m9.577-2.714c0-.79.616-1.386 1.322-1.386s1.323.596 1.323 1.386c0 .562-.317 1.034-.758 1.253-.573.285-1.465.943-1.465 2.033v.54a.9.9 0 0 0 1.8 0v-.54c0-.006 0-.05.077-.139a1.3 1.3 0 0 1 .389-.282 3.19 3.19 0 0 0 1.757-2.865c0-1.736-1.374-3.186-3.123-3.186-1.748 0-3.122 1.45-3.122 3.186a.9.9 0 1 0 1.8 0M12 18.333a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcQuestionCircleLargeFill;
